export const convertToSent = (str: any) => {
    return str?.replace(/^Send/, 'Sent');
}